import React, {Component} from 'react';
import './FormsPage.css';
import Page from '../../components/page/Page'
import UpdateTitle from "../../components/updateTitle/UpdateTitle";
import Divider from "../../components/divider/Divider";
import Card from "../../components/card/Card";
import ReportsTabBar from "../../components/reportsTabBar/ReportsTabBar";
import ReportCard from "../../components/reportCard/ReportCard";

export default class FormsPage extends Component {
  render(){
    return(
    <Page className="g-forms-page">
			<UpdateTitle newTitle="Forms" originalTitle="LogRx" />
			<Card className="main">
				<ReportsTabBar/>
				<Divider/>
				<div className="reports">
					<ReportCard
						url="/forms/ny3848"
						title="NY State 3848"
						description="Semi-anual inventory form"
					/>
				</div>
			</Card>
    </Page>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/formsPage/FormsPage.jsx